import React, { useEffect, useState } from 'react'
import { Icon } from '../Icons.jsx'
import { portal } from '../portalApi.js'

// 알림 종 — 두 곳에서 온다.
//   note  서랍(메모) @멘션.  회사별 DB 에 살고 note_id 를 갖는다.
//   work  업무관리(지시·요청·댓글·완료·확인).  본사 DB 에 살고 work_id 를 갖는다.
// 두 줄기를 한 종에 합친다. 사람은 알림이 어느 표에서 왔는지 궁금하지 않고,
// 종이 둘이면 둘 다 안 보게 된다.

const 업무문구 = {
  지시: '지시를 받았습니다', 요청: '요청을 받았습니다', 일반: '업무가 등록됐습니다',
  댓글: '댓글', 완료: '완료했습니다', 대기: '대기로 바뀌었습니다',
  확인: '받은 것을 확인했습니다', 배정: '담당자로 지정됐습니다',
  일지댓글: '업무일지에 댓글',
}

export default function NotificationBell({ targetLabels, onNavigate }) {
  const [unread, setUnread] = useState(0)
  const [open, setOpen] = useState(false)
  const [items, setItems] = useState(null)

  // 권한이 없는 쪽은 403 이 난다. 그건 오류가 아니라 "그 알림은 없다"는 뜻이므로 0 으로 센다.
  const 세기 = async (url) => {
    try { return (await portal.get(url)).unread || 0 } catch { return 0 }
  }

  useEffect(() => {
    const load = async () => {
      const [n, w] = await Promise.all([
        세기('/api/notes/notifications/unread-count'),
        세기('/api/work/notifications/unread-count'),
      ])
      setUnread(n + w)
    }
    load()
    const t = setInterval(load, 45000)
    return () => clearInterval(t)
  }, [])

  const openList = async () => {
    const next = !open
    setOpen(next)
    if (!next) return
    setItems(null)
    const 받기 = async (url) => { try { return await portal.get(url) } catch { return null } }
    const [n, w] = await Promise.all([
      받기('/api/notes/notifications/list'),
      받기('/api/work/notifications/list'),
    ])
    const 메모 = (n?.notifications || []).map((x) => ({ ...x, kind: 'note' }))
    const 업무 = (w?.notifications || []).map((x) => ({
      ...x, kind: 'work', is_read: x.읽음,
      // 일지 댓글은 업무 한 건이 아니라 그날 일지가 목적지다. 업무명이 없으므로
      // 제목을 날짜와 사람으로 짓는다 — 종만 보고 어디로 가는지 알아야 누른다.
      제목: x.journal_id
        ? `업무일지 · ${x.일지일자} ${x.일지작성자명 || ''}`
        : `업무관리 · ${x.업무명}`,
      줄: `${x.보낸이명 || ''}: ${업무문구[x.종류] || x.종류}${x.내용 && ['댓글', '일지댓글'].includes(x.종류) ? ` — ${x.내용}` : ''}`,
    }))
    // 최신이 위로. 두 표의 id 는 서로 겹치므로 시각으로만 줄 세운다.
    const 합침 = [...메모, ...업무].sort(
      (a, b) => String(b.created_at || '').localeCompare(String(a.created_at || '')))
    setItems(합침)
    setUnread((n?.unread || 0) + (w?.unread || 0))
  }

  const click = async (x) => {
    setOpen(false)
    const url = x.kind === 'work'
      ? `/api/work/notifications/${x.id}/read`
      : `/api/notes/notifications/${x.id}/read`
    portal.post(url).catch(() => {})
    if (!x.is_read) setUnread((u) => Math.max(0, u - 1))
    onNavigate(x)
  }

  return (
    <div style={{ position: 'relative' }}>
      {/* 상단바에 서는 단추다 - 회사 규격대로 모노톤 선 아이콘을 쓴다(이모지 아님) */}
      <button type="button" className="tb-btn" onClick={openList} title="알림 (서랍 멘션 · 업무관리)">
        <Icon.bell />{unread > 0 ? ` ${unread}` : ''}
      </button>
      {open && (
        <div className="vendor-sugs note-bell-panel">
          {items === null && <div className="muted" style={{ padding: 10 }}>불러오는 중…</div>}
          {items?.length === 0 && <div className="muted" style={{ padding: 10 }}>알림이 없습니다</div>}
          {items?.map((x) => (
            <button key={`${x.kind}-${x.id}`} type="button" className="note-bell-item"
              onClick={() => click(x)}>
              <div style={{ fontWeight: x.is_read ? 400 : 700 }}>
                {x.kind === 'work'
                  ? x.제목
                  : `${targetLabels[x.target] || x.target} · ${x.context_label || '전체'}`}
              </div>
              <div className="muted" style={{ fontSize: 11 }}>
                {x.kind === 'work' ? x.줄 : `${x.author_name}: ${String(x.content).slice(0, 60)}`}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
